module.exports = __webpack_public_path__ + "img/混动.0d5679b7.jpeg";